import { v5 as uuidv5 } from "uuid";
import ReactTilt from "react-universal-tilt";
import tinycolor from "tinycolor2";

import "./styles.css";

const uuid = uuidv5(
  fxhash,
  "1b5911b7-ad43-5284-9bc0-e49451f06c68"
).toUpperCase();

const generatedBgColor = "#" + uuid.slice(0, 6);

window.$fxhashFeatures = {
  background: generatedBgColor,
  startsWith: uuid.slice(0, 3),
  endsWith: uuid.slice(-3),
  startsWithLetter: !(Number(uuid[0]) >= 0),
  endsWithLetter: !(Number(uuid.slice(-1)) >= 0),
};
export default function App() {
  return (
    <div
      className="App"
      style={{
        boxShadow: "0px 0px 34px -25px #2eacdd inset",
        background: `linear-gradient(332deg, #081216 33%, ${generatedBgColor} 50%, #081216 66%) #081216`,
      }}
    >
      <ReactTilt
        settings={{
          speed: 15000,
          reverse: true,
        }}
        style={{ transformStyle: "preserve-3d" }}
        className="tilt-elem my-tilt"
      >
        <div
          style={{
            width: "520px",
            height: "520px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#fff",
              width: "420px",
              height: "420px",
              width: "75%",
              height: "75%",
              padding: "25px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: `radial-gradient(
                #000 25%,
                rgba(100, 100, 100, 0.1) 60%,
                rgba(0, 0, 0, 0.1) 66%
              )
              rgba(0, 0, 0, 0.02)`,
              flexWrap: "wrap",
              textShadow: `2px 2px 3px rgba(255, 255, 255, 0.5), 0 0 10px #000`,
              boxShadow: `0 5px 16px rgba(255, 255, 255, 0.3), inset 0 6.9px 25px ${tinycolor(
                generatedBgColor
              )
                .darken(60)
                .desaturate(60)}, inset 6.9px 0 5px ${tinycolor(
                generatedBgColor
              ).darken(100)}, inset 0 -6.9px 5px ${tinycolor(generatedBgColor)
                .darken(60)
                .desaturate(60)}, inset -6.9px 0 5px ${tinycolor(
                generatedBgColor
              ).darken(100)}`,
              border: "10px solid rgb(0 0 0 / 11%)",
              borderRadius: "8px",
            }}
          >
            <p
              style={{
                fontSize: "17px",
                fontWeight: "600",
              }}
            >
              {uuid}
            </p>
          </div>
        </div>
      </ReactTilt>
    </div>
  );
}
